export default {
  'bindTo': 'this',
  'method': function(){
    alert('Messa in mora')
  },
}
